import { PAGE_URL, SESSION_STORAGE_KEYS } from "models/common.models";
import { authClient, OKTA_SCOPES, redirectLoginHandler } from "./OktaUtility";
import { DATADOG_LOG_TYPE, datadogLogger } from "./utilCommon";

export const restoreOktaSession = async (props) => {
  const { oktaAuth, sessionToken, redirectUrl, callback, history, errorHandler } = props;
  try {
    const res = await oktaAuth?.token?.getWithoutPrompt({
      ...(sessionToken && { sessionToken: sessionToken }),
      scopes: OKTA_SCOPES,
    });
    if (!res?.tokens?.accessToken || !res?.tokens?.idToken) {
      if (errorHandler) {
        errorHandler();
        return;
      }
      redirectLoginHandler(true, "", false);
      return;
    }
    oktaAuth?.tokenManager?.setTokens(res?.tokens);
    const redirectCallbackUrl = window.sessionStorage.getItem(
      SESSION_STORAGE_KEYS.REDIRECT_CALLBACK_URL,
    );
    if (
      sessionToken &&
      ((redirectUrl ?? "").toLowerCase() === PAGE_URL.MYASTM.toLowerCase() ||
        !redirectUrl) &&
      history &&
      !redirectCallbackUrl
    ) {
      history.replace(`${redirectUrl ? redirectUrl : ""}`);
      return;
    }
    callback && callback(true);
  } catch (error) {
    datadogLogger(
      `Okta Silent renew failed: ${error ?? ''}`,
      {},
      DATADOG_LOG_TYPE.error,
      {
        name: `Okta Silent renew failed: ${error ?? ''}`,
        message: error,
      },
    );
    if (errorHandler) {
      errorHandler();
      return;
    }
    redirectLoginHandler(true, "", false);
  }
};

// This function is used check okta storage available in authstate with key existance validation(to handle stale login case) .
export const isOKTAStorageAvailableWithRequiredkey = async () => {
  const isSessionExist = await authClient.session.exists();

  if (!isSessionExist) {
    return false;
  }

  let result = false;

  await restoreOktaSession({
    oktaAuth: authClient,
    callback: (response) => {
      result = response;
    },
  });

  return result;
};
